/**
 * Shared frontend configuration constants.
 *
 * API_BASE resolves to the VITE_API_URL build-time env var, falling back
 * to an empty string (relative paths — useful for same-origin dev).
 */
export const API_BASE = import.meta.env.VITE_API_URL ?? '';
